<template>
  <div class="login">
    <!-- 登录模块 -->
    <div class="con">
      <div class="tit">出口价管理平台</div>
      <div class="userId">
        <div class="item">
          <div class="inp">
            <input
              type="text"
              class="name"
              v-model="username"
              placeholder="请输入账号"
            />
          </div>
          <div class="icon">
            <i class="el-icon-user"></i>
          </div>
        </div>
      </div>
      <div class="userPwd">
        <div class="item">
          <div class="inp">
            <input
              :type="type"
              class="pwd"
              v-model="password"
              placeholder="请输入密码"
              @keyup="keuup"
            />
          </div>
          <div class="icon" @click="isShow">
            <i class="el-icon-view"></i>
          </div>
        </div>
      </div>
      <div class="submit">
        <el-button
          class="btn"
          type="primary"
          :loading="disabled"
          @click="mysubmit"
          >登录</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { login, getPermissionList } from "../../api/api";
export default {
  data() {
    return {
      type: "password",
      isPwd: false, // 判断密码是否显示
      disabled: false, //禁用按钮
      username: "",
      password: "",
    };
  },
  methods: {
    isShow() {
      this.isPwd = !this.isPwd;
      if (this.isPwd) {
        this.type = "text";
        return;
      }
      this.type = "password";
    },
    mysubmit() {
      if (this.username == "" || this.password == "") {
        this.$message.error("请输入姓名或密码");
        return;
      }
      // 拿到localStorage,在里面放数据
      var storage = window.localStorage;
      this.disabled = true;
      login({
        username: this.username,
        password: this.password,
      })
        .then((msg) => {
          let { data } = msg;
          data = JSON.parse(data);
          console.log("data", data.users);
          let token = data.access_token;
          let user = JSON.stringify(data.users);
          storage.setItem("token", token);
          storage.setItem("user", user);
          console.log("auth_permissions",data)
          if (data.users.id == 1) {
            getPermissionList().then((msg) => {
              let { data } = msg;
              data = JSON.parse(data).data;
              
              storage.setItem(
                "auth_permissions",
                JSON.stringify(data)
              );
            });
          } else {
            
            storage.setItem(
              "auth_permissions",
              JSON.stringify(data.users.auth_permissions)
            );
          }
          setTimeout(() => {
            this.$router.push("/");
            this.$message({
              message: "登录成功",
              type: "success",
            });
            this.disabled = false;
          }, 2000);
        })
        .catch((msg) => {
          this.$message.error("登陆失败");
          this.disabled = false;
        });
    },
    keuup(e) {
      if (e.keyCode == 13) {
        this.mysubmit();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
*:focus {
  outline: none;
}
.login {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../assets/img/000.jpg") no-repeat center;
  background-size: cover;
  .con {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    background: #fff;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    padding: 50px 70px;
    box-sizing: border-box;
    border-radius: 10px;

    .tit {
      color: #333;
      font-size: 26px;
      font-weight: 500;
      text-align: center;
      margin-bottom: 30px;
    }
    .item {
      height: 50px;
      display: flex;
      border: 1px solid #dedede;
      background: #fff;
      margin-bottom: 20px;
      border-radius: 5px;
      overflow: hidden;
      .inp {
        width: 100%;
      }
      .icon {
        width: 50px;
        text-align: center;
        line-height: 50px;
        border-left: 1px solid #dedede;
      }

      .name,
      .pwd {
        width: 100%;
        height: 100%;
        padding: 0 20px;
        border: none;
        font-size: 18px;
        box-sizing: border-box;
      }
    }

    .submit {
      width: 100%;
      height: 50px;
      text-align: center;
      line-height: 50px;
      .btn {
        width: 100%;
        height: 100%;
        border: none;
        color: #fff;
        border-radius: 5px;
        background: #35bde5;
        font-size: 18px;
      }
      .btns {
        width: 100%;
        height: 100%;
        border: none;
        color: #333;
        border-radius: 5px;
        font-size: 18px;
        background: #ccc;
      }
    }
  }
}
</style>